import { render } from "./AddValidityPerionModal.vue?vue&type=template&id=f0aabd3a&ts=true"
import script from "./AddValidityPerionModal.vue?vue&type=script&lang=ts"
export * from "./AddValidityPerionModal.vue?vue&type=script&lang=ts"

import "./AddValidityPerionModal.vue?vue&type=style&index=0&id=f0aabd3a&lang=scss"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__